import React from 'react'
import { FormattedMessage } from 'react-intl'
import { accentuate } from '../'
import { Section, ExternalLinkBlock, Heading } from '../s'
import Paragraph from 'components/typography/paragraph'

const XledgerSecurityAndCompliance = ({ data }) => (
    <Section>
        <Heading>
            <FormattedMessage
                id="integration_heading_security_compliance"
                defaultMessage="Security and compliance" />
        </Heading>
        <Paragraph>
            <FormattedMessage
                id="integration_xledger_preamble_security_compliance"
                defaultMessage="By connecting with Xledger, you authorize Huma to access your Xledger account as described in our Terms of Service under <accent>Third-Party Platforms</accent>."
                values={{ accent: accentuate }} />
        </Paragraph>
        {data?.externalLinks?.map(({ url, label }, index) => (
            <ExternalLinkBlock
                href={url}
                key={`${data.name}:${index}:${url}`}>
                <FormattedMessage {...label} />
            </ExternalLinkBlock>
        ))}
    </Section>
)

export default XledgerSecurityAndCompliance